module.exports = __webpack_public_path__ + "cjml_app_pcui/img/pic_02.2151fc96.png";